module.exports = __webpack_public_path__ + "assets/roboto-v30-latin_latin-ext-regular.221b2e1078cfb56ce34500ac0066fdcf.woff";